import { Card, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

const NoCampaignCard = () => {
  const navigate = useNavigate();
  return (
    <Card className="campaign-video-card">
      <div className="dashed-container">
        <img
          src={require("@src/assets/images/vyrill/campaign-icon.png").default}
          alt=""
          width={91}
        />
        <h1 className="homepage-heading ">
          Let’s build your first Video Campaign!
        </h1>
        <p className="homepage-description">
          Save valuable time with our pre-built campaign template. Once
          published, your new campaign can be swiftly and effortlessly shared
          with your network.
        </p>
        <Button
          className="campaign-button"
          size="lg"
          color="primary"
          onClick={() => {
            navigate("/create_campaign");
          }}
        >
          Create
        </Button>
      </div>
    </Card>
  );
};

export default NoCampaignCard;
